import { Grid, LinearProgress, Typography } from "@mui/material";
import type { FC } from "react";
import type { ID } from "../../data/BaseEntity";
import { useCustomerOrdersStats } from "./useCustomerOrdersStats";

interface StatsForStatusProps {
  readonly name: string;
  readonly numberOfOrders: number;
  readonly plnValue: number | null;
  readonly eurValue: number | null;
}

const StatsForStatus: FC<StatsForStatusProps> = ({ name, numberOfOrders, plnValue, eurValue }) => (
  <Grid container size={12}>
    <Grid size={12}>
      <Typography variant="subtitle2">
        {name} ({numberOfOrders})
      </Typography>
    </Grid>
    <Grid size={6}>
      <Typography>{plnValue} PLN</Typography>
    </Grid>
    <Grid size={6}>
      <Typography>{eurValue} EUR</Typography>
    </Grid>
  </Grid>
);

interface Props {
  readonly customerId: ID;
  readonly year: number;
}

const CustomerOrdersStats: FC<Props> = ({ customerId, year }) => {
  const { ordersStats, isLoading } = useCustomerOrdersStats(customerId, year);
  if (isLoading) {
    return (
      <Grid container data-testid="customer-order-stats">
        <Grid size={12}>
          <LinearProgress data-testid="loading-indicator" />
        </Grid>
      </Grid>
    );
  }
  if (!ordersStats) {
    return <Grid container data-testid="customer-order-stats" />;
  }

  return (
    <Grid
      container
      data-testid="customer-order-stats"
      sx={{
        rowGap: 2,
      }}
    >
      <StatsForStatus
        name="Potwierdzenie wysłane"
        numberOfOrders={ordersStats.initial.numberOfOrders}
        plnValue={ordersStats.initial.plnValue}
        eurValue={ordersStats.initial.eurValue}
      />
      <StatsForStatus
        name="Podpisane potwierdzenie"
        numberOfOrders={ordersStats.confirmed.numberOfOrders}
        plnValue={ordersStats.confirmed.plnValue}
        eurValue={ordersStats.confirmed.eurValue}
      />
      <StatsForStatus
        name="Opłacone"
        numberOfOrders={ordersStats.paid.numberOfOrders}
        plnValue={ordersStats.paid.plnValue}
        eurValue={ordersStats.paid.eurValue}
      />
      <StatsForStatus
        name="Anulowane"
        numberOfOrders={ordersStats.cancelled.numberOfOrders}
        plnValue={ordersStats.cancelled.plnValue}
        eurValue={ordersStats.cancelled.eurValue}
      />
    </Grid>
  );
};

export default CustomerOrdersStats;
